<template>
  <v-layout>
    <div style="width: calc(100% - 115px);" class="top-menu">
      <div class="menu-outer">
        <div class="menu-inner">
          <template
            v-for="(key, menuIndex) in Object.keys(menu)"
          >
            <div
              v-if="menu[key]['menuName_' + lang] && menu[key].showOnDesktop"
              :key="menuIndex + 'tm'"
              class="menu-level-1"
              @mouseenter="showMenu(key)"
              @mouseleave="hideMenu()"
            >
              <div
                @click="showPageId(menu[key])"
              >
                {{ menu[key]['menuName_' + lang] }}
              </div>
              <template v-if="menu[key].children && menu[key].children.length > 0 && showMenuId === key">
                <div class="submenu">
                  <div
                    v-for="(submenuItem, menuIndex2) in menu[key].children.filter(menu => menu.showOnDesktop)"
                    :key="menuIndex + '_' + menuIndex2 + '_tm'"
                    class="menu-level-2"
                    @click="showPageId(submenuItem)"
                  >
                  {{ submenuItem['menuName_' + lang] }}
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="menu-outer top-menu-social" style="width: 115px;">
      <a href="https://www.facebook.com/costasolrent/" target="_blank" class="menu-bar-logo">
        <img src="/img/facebook-logo.png" />
      </a>
      <a href="https://www.instagram.com/costasolrent.fi/" target="_blank" class="menu-bar-logo">
        <img src="/img/instagram-logo.png" />
      </a>
    </div>
  </v-layout>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'TopMenu',

  data () {
    return {
      showMenuId: null,
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    menu () {
      let menu = {}
      // level 1
      this.menuResponse.forEach(item => {
        if (!item.parent) {
          menu[item._id] = item
          menu[item._id].children = []
        }
      })
      // level 2
      this.menuResponse.forEach(item => {
        if (item.parent && item.parent._id && menu[item.parent._id]) {
          menu[item.parent._id].children.push(item)
        }
      })
      return menu
    }
  },

  methods: {
    ...sharedMethods,

    showMenu (id) {
      this.showMenuId = id
    },

    hideMenu () {
      this.showMenuId = null
    }
  }
}
</script>

<style>
.top-menu-social {
  padding-top: 7px;
  font-size: 24px;
  overflow: hidden;
  line-height: 32px;
  text-align: right;
  padding-right: 5px;
}
.top-menu-social a {
  color: white;
  padding-right: 7px;
}
.menu-bar-logo img {
  height: 31px;
  padding-top: 5px;

}
</style>
